import { Danish } from "flatpickr/dist/l10n/da.js"
import { German } from "flatpickr/dist/l10n/de.js"
import { english} from "flatpickr/dist/l10n/default.js"

let language
switch (window.app.language) {
    case 'de':
        language = German
        break
    case 'en':
        language = english
        // Week numbers doesn't work properly if firstDayOfWeek is sunday.
        language.firstDayOfWeek = 1
        break
    default:
        language = Danish
}

export { language }
